'use client';
import React, { useEffect } from 'react';

function Navbar() {
  function handleScroll() {
    const bodyScroll = window.scrollY;
    const navbar = document.querySelector('.navbar');

    if (bodyScroll > 300) navbar.classList.add('nav-scroll');
    else navbar.classList.remove('nav-scroll');
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleToggleNav() {
    const collapse = document.querySelector('.navbar .navbar-collapse');
    if (collapse.classList.contains('show')) {
      collapse.classList.remove('show');
    } else {
      collapse.classList.add('show');
    }
  }

  function handleAnchorClick(event, targetId) {
    event.preventDefault();
    if (targetId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(targetId);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    const collapse = document.querySelector('.navbar .navbar-collapse');
    if (collapse && collapse.classList.contains('show')) {
      collapse.classList.remove('show');
    }
  }

  const sections = [
    { id: 'services', label: 'Soluções' },
    { id: 'portfolio', label: 'Portfólio' },
    { id: 'contact', label: 'Contato' },
  ];

  return (
    <nav className="navbar navbar-expand-lg bord blur">
      <div className="container o-hidden">
        <a
          className="logo icon-img-100"
          href="#home"
          onClick={(e) => handleAnchorClick(e, 'home')}
        >
          <img src="/assets/imgs/logo-light.png" alt="logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleToggleNav}
        >
          <span className="icon-bar">
            <i className="fas fa-bars"></i>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            {sections.map((section) => (
              <li key={section.id} className="nav-item">
                <a
                  className="nav-link"
                  href={`#${section.id}`}
                  onClick={(e) => handleAnchorClick(e, section.id)}
                >
                  <span className="rolling-text">{section.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="contact-button">
          <a
            href="https://wa.me/553198550500"
            target="_blank"
            rel="noreferrer"
            className="butn butn-sm butn-bg main-colorbg radius-5"
            style={{ color: '#000' }}
          >
            <span className="text" style={{ color: '#000' }}>
              Falar com especialista
            </span>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
